import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=1c46818f&scoped=true&"
import script from "./Privacy.vue?vue&type=script&lang=js&"
export * from "./Privacy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=1c46818f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c46818f",
  null
  
)

export default component.exports